/**
 * Name of the cookie that stores the serialized auth tokens
 * (`{ token, refreshToken, tokenExpires }`).
 *
 * Shared between the client `AuthProvider` (which writes it via `js-cookie`)
 * and server-side code that needs to read the token to make authenticated
 * requests during render (e.g. payment-source prefetch). Keep both in sync.
 */
export const AUTH_TOKEN_COOKIE = "auth-token-data";

/**
 * Lifetime of the auth cookie, deliberately not derived from `tokenExpires`:
 * the browser expires cookies on the device clock, and the backend's 401 is
 * what ends a session. Keep it longer than the backend token lifetime.
 */
export const AUTH_TOKEN_COOKIE_EXPIRES_DAYS = 7;
